import { render, staticRenderFns } from "./InfieldSettings.vue?vue&type=template&id=119842f3&scoped=true&lang=html&"
import script from "./InfieldSettings.vue?vue&type=script&lang=js&"
export * from "./InfieldSettings.vue?vue&type=script&lang=js&"
import style0 from "./InfieldSettings.vue?vue&type=style&index=0&id=119842f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119842f3",
  null
  
)

export default component.exports